import PropTypes from 'prop-types'

export const DownloadCodesIcon = ({title = null}) => (
  <svg
    aria-hidden={!title}
    fill='none'
    height='20px'
    role={title ? 'img' : null}
    viewBox='0 0 20 20'
    width='20px'
    xmlns='http://www.w3.org/2000/svg'>
    {title ? <title>{title}</title> : null}
    <path
      d='M2.5 13.75V15.625C2.5 16.1223 2.69754 16.5992 3.04917 16.9508C3.40081 17.3025 3.87772 17.5 4.375 17.5H15.625C16.1223 17.5 16.5992 17.3025 16.9508 16.9508C17.3025 16.5992 17.5 16.1223 17.5 15.625V13.75M13.75 10L10 13.75M10 13.75L6.25 10M10 13.75V2.5'
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth='1.5'
    />
  </svg>
)

DownloadCodesIcon.propTypes = {title: PropTypes.string}
